import React, {Component} from 'react';
import PropTypes from "prop-types";
import StaticFunctions from "./StaticFunctions";

import "../css/style-table.css";

class TableContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        columns: PropTypes.array.isRequired,
        rows: PropTypes.array.isRequired,
    };

    static defaultProps = {
        name: '',
        tableClasses: null,
        fillGaps: null,
        maxHeight: 800,
        maxWidth: 'none',
        onClick: null,
        noDataKey: 'noDataFound',
        formatedDatetime: null,
        initSort: {
            column: null,
            order: 'asc',
            type: null,
        },
    };

    constructor(props) {

        super(props);

        this.state = {
            sortColumn: props.initSort.column,
            sortType: props.initSort.type,
            sortOrder: (props.initSort.order === 'asc' || props.initSort.order === 'desc') ? props.initSort.order : 'asc',
        };

        this.translate = this.props.baseData.translate;
        this.userLanguage = this.props.baseData.userData.language;
        this.timeFormats = this.props.baseData.languages.getFormatByLanguage(this.userLanguage);

        this.clickHandle = this.clickHandle.bind(this);
        this.setTableSort = this.setTableSort.bind(this);
        this.resetTableSort = this.resetTableSort.bind(this);

    }

    clickHandle(id) {

        if (this.props.onClick) return () => this.props.onClick(id);

        return () => {};

    }

    getTableHead() {

        const tableName = (this.props.name) ? this.props.name + '-' : '';
        const columns = this.props.columns;
        const tableHead = [];

        for (let i = 0; i < columns.length; i++) {
            let column = columns[i];
            let columnName = (column.name) ? column.name : (column.nameKey) ? this.translate(column.nameKey) : 'Column ' + i;
            let columnClasses = (column.classes) ? column.classes : 'text-left';
            let columnSortType = (column.sortType !== undefined) ? column.sortType : null;
            let classes = [columnClasses, ((columnSortType) ? 'sortable' : ''), (column.key === this.state.sortColumn) ? this.state.sortOrder : ''].join(' ').trim();
            let sortIcon = (columnSortType) ? <span className="sort">&nbsp;</span> : '';

            tableHead.push(
                <th key={tableName + 'column-' + i} className={classes} onClick={() => this.setTableSort(column.key, columnSortType)}>
                    {columnName}{sortIcon}
                </th>
            );
        }

        return <tr>{tableHead}</tr>;

    }

    getTableBody() {

        const tableName = (this.props.name) ? this.props.name + '-' : '';
        const columns = this.props.columns;
        const rows = (this.state.sortColumn) ? this.getSortedRows() : this.props.rows;
        const tableBody = [];

        for (let i = 0; i < rows.length; i++) {
            let rowData = rows[i];
            let rowId = rowData.id;
            let rowTemp = [];
            let trClasses = [((rowData.trClasses) ? rowData.trClasses : ''), ((rowId === 'sum') ? 'trSum' : ''), ((rowData.statusMsg) ? rowData.statusMsg : '')].join(' ').trim();

            columns.forEach((column, index) => {
                let tdClass = (column.classes) ? column.classes : 'text-left';
                let tdContent = this.getTdContent(rowData[column.key], column.key);

                rowTemp.push(
                    <td key={tableName + 'td-' + index} className={tdClass}>
                        {tdContent}
                    </td>
                );
            });

            tableBody.push(
                <tr key={tableName + 'row-' + i} className={trClasses} onClick={this.clickHandle(rowId)}>
                    {rowTemp}
                </tr>
            );
        }

        return tableBody;

    }

    getSortedRows() {

        //const rows = [].concat(this.props.rows);
        const rowsWithoutSum = this.getRowsWithoutSum();
        const sumRow = this.getSumRow();
        const column = this.state.sortColumn;
        const order = this.state.sortOrder;
        const type = this.state.sortType;
        const formatedDatetime = (this.props.formatedDatetime) ? this.props.formatedDatetime : this.timeFormats.fullDate;
        const sortedRows = StaticFunctions.getSortedData(rowsWithoutSum, column, type, formatedDatetime, order);

        return sortedRows.concat(sumRow);

    }

    getRowsWithoutSum() {

        const rows = this.props.rows;

        return rows.filter(
            (row) => {
                return row.id !== 'sum';
            }
        );

    }

    getSumRow() {

        const rows = this.props.rows;

        return rows.filter(
            (row) => {
                return row.id === 'sum';
            }
        );

    }

    getTdContent(content, columnKey) {

        let tdContent = this.props.fillGaps;

        if (content || content === 0 || content === '0') {
            switch (columnKey) {
                case 'statusMsg':
                    tdContent = <i>{content}</i>;
                    break;

                default:
                    tdContent = content;
                    break;
            }
        }

        return tdContent;

    }

    setTableSort(sortColumn, sortType) {

        if (sortType) {
            if (sortColumn === this.state.sortColumn) {
                this.setState({
                    sortOrder: (this.state.sortOrder === 'asc') ? 'desc' : 'asc'
                });
            } else {
                this.setState({
                    sortColumn: sortColumn,
                    sortOrder: 'asc',
                    sortType: sortType,
                });
            }
        }

        return null;

    }

    resetTableSort() {

        this.setState({
            sortColumn: null,
            sortOrder: 'asc',
            sortType: null,
        });

    }

    render() {

        const tHead = this.getTableHead();
        const tBody = this.getTableBody();

        if (tBody.length === 0 && !this.props.noDataKey) return null;
        if (tBody.length === 0) return <span className="noDataFound">{this.translate(this.props.noDataKey)}</span>;

        const tableClasses = ['table', ((this.props.tableClasses) ? this.props.tableClasses : ''), ((this.props.onClick) ? 'table-hover' : '')].join(' ').trim();
        const containerSytle = {maxHeight: this.props.maxHeight, maxWidth: this.props.maxWidth};

        return (
            <div className="tableContainer" style={containerSytle}>
                <div className="archivTable tableBox">
                    <table className={tableClasses}>
                        <thead>
                            {tHead}
                        </thead>

                        <tbody>
                            {tBody}
                        </tbody>
                    </table>
                </div>
            </div>
        );

    }

}

export default TableContainer;